import { render, staticRenderFns } from "./StaffEdit.vue?vue&type=template&id=12b5f6b1"
import script from "./StaffEdit.vue?vue&type=script&lang=js"
export * from "./StaffEdit.vue?vue&type=script&lang=js"
import style0 from "./StaffEdit.vue?vue&type=style&index=0&id=12b5f6b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports